import React, { useState } from 'react';
import { useDispatch, shallowEqual, useSelector } from "react-redux";
//ACCIONES PARA DISPATCH
import * as actionsDetalleInscripcion from '../_redux/DetalleInscripcion/DetalleInscripcionActions'
//Formik
import { Formik, Field, Form, ErrorMessage } from 'formik';
import * as Yup from 'yup';
import { Button, Spinner } from 'react-bootstrap';

//SNACK PARA VER EL ERROR
import SnackBarCustom from '../../../Comun/SnackBars/SnackBarCustom';

//RADIO BUTTONS
import { Radio, RadioGroup, FormControlLabel, Card, CardContent } from '@material-ui/core';

//ICONOS
import ErrorIcon from '@material-ui/icons/Error';

//ESQUEMA DE FORMULARIO
const documentoNumeroSchema = Yup.object().shape({
    documentoNumero: Yup.string()
        .matches(/^\d+$/, "Solo debe ingresar números")
        .required("Debe ingresar el número de documento"),
});
const inscripcionCodigoSchema = Yup.object().shape({
    inscripcionCodigo: Yup.string()
        .matches(/^\w+$/, "Solo debe ingresar números y letras")
        .min(6, "Debe ingresar 6 carácteres o mas")
        .max(9, "Solo se permiten 9 carácteres")
        .required("Debe ingresar el código de inscripción asociado al aspirante"),
});
//VALORES INICIALES FORMIK
const inscripcionValoresIniciales = {
    documentoNumero: '',
    inscripcionCodigo: '',
};

const BuscarInscripcion = () => {
    //ESTADO PARA BUSCAR POR NÚMERO DE DOCUMENTO O CODIGO DE INSCRIPCIÓN
    const [buscarDocumento, setBuscarDocumento] = useState(true);
    //DISPATCH
    const dispatch = useDispatch();

    const { listLoading, error } = useSelector(
        state => state.detalleInscripcion,
        shallowEqual
    );
    return (
        <>
            <Formik
                enableReinitialize
                initialValues={inscripcionValoresIniciales}
                validationSchema={buscarDocumento ? documentoNumeroSchema : inscripcionCodigoSchema}
                onSubmit={(values, { setSubmitting }) => {
                    setTimeout(() => {
                        const { inscripcionCodigo, documentoNumero } = values;
                        //console.log(values);
                        dispatch(actionsDetalleInscripcion.fetchDetalleInscripcionInformacion({ codigo: inscripcionCodigo, documento: documentoNumero }));
                        setSubmitting(false);
                    }, 500);
                }}
            >
                {formik =>
                    <Form>
                        <h3 className="text-center pb-5">Detalle de Inscripción</h3>
                        <div className="form-group">
                            <h6 >Buscar inscripción por:</h6>
                            <RadioGroup
                                className="pl-2"
                                aria-label="position"
                                value={buscarDocumento}
                                onChange={() => {
                                    formik.resetForm();
                                    setBuscarDocumento(!buscarDocumento);
                                }}>
                                <FormControlLabel value={true} control={<Radio color="primary" />} label="DNI" />
                                <FormControlLabel value={false} control={<Radio color="primary" />} label="Código de Inscripción" />
                            </RadioGroup>
                        </div>
                        {!buscarDocumento &&
                            <div className="row justify-content-center">
                                <Card className="col-12 col-md-8" style={{ backgroundColor: "#f7f7f7" }}>
                                    <CardContent className="d-flex align-items-center ml-2">
                                        <div className="border-left border-2 border-primary p-3 br-4">
                                            <ErrorIcon color="secondary" fontSize="large" />
                                        </div>
                                        <div>
                                            <b>AVISO</b>
                                            <p>El código de inscripción fue enviado al correo con el cual se registró para realizar la inscripción</p>
                                        </div>
                                    </CardContent>
                                </Card>
                            </div>
                        }
                        <div className="row justify-content-center align-items-top mt-5" >
                            {buscarDocumento ?
                                <div className="form-group col-12 col-md-6 justify-content-bottomm">
                                    <label htmlFor="documentoNumero">Ingresar DNI del Aspirante*</label>
                                    <Field name="documentoNumero" type="text" maxLength={15} className="form-control" placeholder="12345678" />
                                    <small>Solo números sin puntos o comas</small>
                                    <div className="text-danger"><ErrorMessage name="documentoNumero" /></div>
                                </div>
                                :

                                <div className="form-group col-12 col-md-6 justify-content-bottomm">
                                    <label htmlFor="inscripcionCodigo">Ingresar el Código de Inscripción*</label>
                                    <Field name="inscripcionCodigo" type="text" maxLength={9}/*PREGUNTAR A MATI SI ES 9*/ className="form-control" placeholder="X0X0X0X0" />
                                    <small>Solo números y letras</small>
                                    <div className="text-danger"><ErrorMessage name="inscripcionCodigo" /></div>
                                </div>
                            }
                        </div>
                        <div className="row justify-content-center mb-3">
                            {listLoading ?
                                <Spinner animation="border" variant="success" />
                                :
                                <Button variant="success" type="submit">Buscar</Button>
                            }
                        </div>
                        {error && <SnackBarCustom tipo="error" mensaje={error} />}
                    </Form>
                }
            </Formik>
        </>
    )
}

export default BuscarInscripcion;